import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './WatchSuggestionList';
import { unsuggestUser } from './redux/actions';
import { getCurrentUserId } from '../publicSession/selectors';

type StateProps = Pick<Props, 'currentUserId'>;
export type DispatchProps = Pick<Props, 'unsuggestUser'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  currentUserId: getCurrentUserId(state),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  unsuggestUser: userid => dispatch(unsuggestUser({ userid })),
});
export default connect(mapStateToProps, mapDispatchToProps);
